import { errorMessage } from '../utils/messageMutation';
import AddItemToTagMutation from '../_graphql/mutations/documents/AddItemToTagMutation';
import RemoveItemToTagMutation from '../_graphql/mutations/documents/RemoveItemToTagMutation';
import useActionGuard from './useActionGuard';

const useDocumentsTags = (documentId, setRefetchTags, isGlobal = false) => {
  const { loading, run } = useActionGuard();

  const onAddItem = (tagId) => {
    run(`add-tag-${tagId}`, (done) => AddItemToTagMutation({
      itemId: documentId, tagId, isGlobal
    }, done), (ok, error) => {
      if (!ok || error) {
        errorMessage();
      } else if (setRefetchTags) {
        setRefetchTags(true);
      }
    });
  };

  const onRemoveItem = (tagId) => {
    run(`remove-tag-${tagId}`, (done) => RemoveItemToTagMutation({
      itemId: documentId, tagId, isGlobal
    }, done), (ok, error) => {
      if (!ok || error) {
        errorMessage();
      } else if (setRefetchTags) {
        setRefetchTags(true);
      }
    });
  };

  return {
    onAddItem,
    onRemoveItem,
    loading
  };
};

export default useDocumentsTags;
